import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import MonitoringIcon from './components/MonitoringIcon'
import NotificationsIcon from './components/NotificationsIcon'
import SingleEntityContentButton from './components/SingleEntityContentButton'
import MultipleEntitiesContentButton from './components/MultipleEntitiesContentButton'

import { LOCALE_PREFIX } from '../../constants'
import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class GroupsList extends Component {
    static propTypes = {
        groups: IPropTypes.list,
        manageGroupsDialogImport: PropTypes.func.isRequired,
        manageGroupsDialogImportSingle: PropTypes.func.isRequired,
        manageGroupsDialogRemove: PropTypes.func.isRequired,
        rows: IPropTypes.list,
        settings: PropTypes.object,
    }

    static defaultProps = {
        groups: List(),
        settings: [],
        rows: List(),
    }

    handleAddToGroup = (groupId, index) => {
        const { settings, manageGroupsDialogImport, manageGroupsDialogImportSingle } = this.props

        const entities = _.get(settings, 'entities', [])

        if (entities.length === 1) {
            manageGroupsDialogImportSingle(groupId, entities, index)
            return null
        }

        manageGroupsDialogImport(groupId, entities, index)
        return null
    }

    handleRemoveFromGroup = (groupId, index) => {
        const { settings, manageGroupsDialogRemove } = this.props

        const entities = _.get(settings, 'entities', [])

        manageGroupsDialogRemove(groupId, entities, index)
        return null
    }

    renderContentHandlingButton = (group, index, singleEntity = false) => {
        const { rows } = this.props

        if (singleEntity) {
            return (
                <SingleEntityContentButton
                    handleAddToGroup={this.handleAddToGroup}
                    handleRemoveFromGroup={this.handleRemoveFromGroup}
                    loading={rows.getIn([index, 'loading'], false)}
                    inGroup={rows.getIn([index, 'inGroup'], false)}
                    group={group}
                    index={index}
                />
            )
        }

        return (
            <MultipleEntitiesContentButton
                group={group}
                handleAddToGroup={this.handleAddToGroup}
                index={index}
                loading={rows.getIn([index, 'loading'], false)}
            />
        )
    }

    render() {
        const { groups, settings } = this.props

        const entities = _.get(settings, 'entities', [])
        const singleEntity = entities.length === 1

        return (
            <div className={'manage-groups-groups-list-container'}>
                <div className={'groups-list'}>
                    {groups.map((group, index) => (
                        <div className={'groups-list-item'} key={`groups-list-item-${group.get('id', null)}`}>
                            <div className={'group-control-container'}>
                                {this.renderContentHandlingButton(group, index, singleEntity)}
                            </div>
                            <div className={'group-text-container'}>
                                <div className={'group-name'}>{group.get('name', '')}</div>
                                <div className={'group-members'}>
                                    <span style={{ paddingRight: '4px' }}>
                                        <FormattedMessage id={`${LOCALE_PREFIX}.members`} />
                                    </span>
                                    <span>{group.get('members', null)}</span>
                                </div>
                            </div>
                            <div className={'group-flags-container'}>
                                {group.get('flags', Map()).get('monitoring', false) && <MonitoringIcon index={index} />}
                                {group.get('flags', Map()).get('sendEmails', false) && (
                                    <NotificationsIcon index={index} />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}
